import { Navigation } from "baseui/side-navigation";
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { scrollTop } from '../../animation/scrollTo';
import { CASHFLOW_LINK } from '../flows/linkConstants';


export default ({ submitData, flowStatus }) => {
    const history = useHistory();
    const location = useLocation();

    const getSidebarItems = () => {
        const sidebar = [
            {
                title: 'Profile',
                itemId: '/app/profile',
            },
            {
                title: 'Income',
                itemId: '/app/income',
                subNav: [
                    { title: "Employment", itemId: "/app/income/employment" },
                    { title: "Deductions", itemId: "/app/income/deductions" },
                    { title: "Other", itemId: "/app/income/other" },
                ]
            },
            {
                title: 'Expenses',
                itemId: '/app/expenses',
                subNav: [
                    { title: "Housing", itemId: "/app/expenses/housing" },
                    { title: "Short Term Debts", itemId: "/app/expenses/short-term-debts" },
                    { title: "Household", itemId: "/app/expenses/household" },
                    { title: "Insurance", itemId: "/app/expenses/insurance" },
                ]
            },
            {
                title: 'Portfolio',
                itemId: '/app/portfolio',
            },
            {
                title: 'Social Security',
                itemId: '/app/social-security',
                subNav: [
                    { title: "Expected Benefits", itemId: "/app/social-security/expected-benefits" },
                    { title: "Choice", itemId: "/app/social-security/choice" },
                ]
            },
            {
                title: 'Cash Flow',
                itemId: CASHFLOW_LINK,
            },
        ];

        const processSidebarItems = sidebar => {
            return sidebar.map(sideBarItem => {
                const sideBarItemName = sideBarItem.title.toLowerCase().replace(/\s/g, '-');
                sideBarItem.disabled = flowStatus[sideBarItemName] !== "finished" && flowStatus[sideBarItemName] !== "pending";
                if (sideBarItem.subNav) sideBarItem.subNav = processSidebarItems(sideBarItem.subNav);
                return sideBarItem;
            }
            )
        }
        return processSidebarItems(sidebar);
    }

    return (<div style={{}}>
        <Navigation
            items={getSidebarItems()}
            overrides={{
                Root: {
                    style: ({ $theme }) => {
                        return {
                            height: 'calc(100vh - 105px)',
                            backgroundColor: $theme.colors.contentInverseTertiary,
                            paddingRight: '5px'
                        };
                    }
                },
                NavItemContainer: {
                    style: ({ $theme }) => {
                        return {
                            outline: `${$theme.colors.contentInverseTertiary} solid`,
                            backgroundColor: $theme.colors.contentInverseTertiary,
                        };
                    }
                }
            }}
            activeItemId={location.pathname}
            onChange={({ event, item }) => {
                event.preventDefault(); // prevent page reload
                scrollTop();
                history.push(item.itemId);
                submitData();
            }}
        />
    </div>
    );
}